<div class="fms-about-you">
  <!--
    Issue #538: no partial render while GET v1/user/onboarding/questions is
    in flight — previously the feature grid rendered immediately off the
    local fallback constant while the three selects below were still
    waiting on the fetch, producing a grid-only flash. Everything below now
    mounts together, in one paint, once isLoading flips false (success OR
    error — see AboutYouStepComponent.ngOnInit).
  -->
  <vng-skeleton-rows *ngIf="isLoading" [rows]="4"></vng-skeleton-rows>

  <ng-container *ngIf="!isLoading">
    <ng-container *ngIf="languageQuestion">
      <label class="fms-about-you-label">{{ languageQuestion.question }}</label>
      <vng-select
        placeholder="Select"
        [options]="getSelectOptions(languageQuestion)"
        [(ngModel)]="languageQuestion.answer"
        (ngModelChange)="onLanguageChange()"
        data-fms-heap="walk-me-modal-about-you-language"
      ></vng-select>
    </ng-container>

    <ng-container *ngIf="departmentQuestion">
      <label class="fms-about-you-label">{{ departmentQuestion.question }}</label>
      <vng-select
        placeholder="Select"
        [options]="getSelectOptions(departmentQuestion)"
        [(ngModel)]="departmentQuestion.answer"
        (ngModelChange)="onDepartmentChange()"
        data-fms-heap="walk-me-modal-about-you-department"
      ></vng-select>
    </ng-container>

    <ng-container *ngIf="roleQuestion">
      <label class="fms-about-you-label">{{ roleQuestion.question }}</label>
      <vng-select
        placeholder="Select"
        [options]="getSelectOptions(roleQuestion)"
        [(ngModel)]="roleQuestion.answer"
        (ngModelChange)="onRoleChange()"
        data-fms-heap="walk-me-modal-about-you-role"
      ></vng-select>
    </ng-container>

    <p *ngIf="loadFailed && !languageQuestion && !departmentQuestion && !roleQuestion" class="fms-about-you-error">
      We couldn't load your onboarding questions right now. Try reopening this checklist in a moment.
    </p>

    <p class="fms-about-you-grid-title">What FlyMSG features are you most interested in?</p>
    <div class="fms-about-you-grid">
      <vng-checkbox
        *ngFor="let option of featureOptions"
        [checked]="isFeatureChecked(option)"
        (change)="onFeatureToggle(option, $event.checked)"
        [attr.data-fms-heap]="featureHeapId(option)"
      >
        {{ option }}
      </vng-checkbox>
    </div>

    <div class="fms-about-you-continue-row">
      <button
        vng-button
        variant="accent"
        type="button"
        style="width: 110px"
        [disabled]="!requiredAnswered"
        (click)="onContinue()"
        data-fms-heap="walk-me-modal-about-you-continue"
      >
        Continue
      </button>
    </div>
  </ng-container>
</div>
